import cn from "classnames";
import { ClipLoader } from "react-spinners";

import { LoaderProps } from "./Loader.types";

import styles from "./Loader.module.scss";

const Loader = ({ className, size = 30 }: LoaderProps) => {
  return (
    <div className={cn(styles.loader, className)}>
      <ClipLoader size={size} color="#fb3973" />
    </div>
  );
};

export default Loader;
